import React from "react";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import logo from "../../../public/images/harnois-logo.svg";
import Helpbox from "../components/UI/Helpboxes/Helpbox"

const Footer = () => {
    const {t} = useTranslation();

    return (
        <footer className="footer">
            <div className="container container--larger">
                <div className="row">
                    <div className="col-sm-12 col-md-3">
                        <Link to="/" className="site-logo">
                            <img
                                src={logo}
                                alt={'Harnois ' + t('footer.energy')}
                                title={'Harnois ' + t('footer.energy')}
                            />
                        </Link>
                    </div>
                    <div className="col-sm-12 col-md-6 flex flex--align-center flex--justify-center">
                        <nav id="footer-menu" className={'footer-menu'}>
                            <ul>
                                <li>
                                    <Link to={"/faq"} className="link">
                                        {t("footer.need_help")}
                                    </Link>

                                </li>
                                {/*<li>
                                    <a target="_blank" href={t("footer.in_emergency_link")} className="link link--red">
                                        {t("footer.in_emergency")}
                                    </a>
                                </li>*/} 
                            </ul>
                        </nav>
                    </div>
                    <div className="col-sm-12 col-md-3 flex flex--align-end flex--justify-center flex-column">
                        <div id="copyright">
                            ©&nbsp;Harnois&nbsp;{t("footer.energy")}&nbsp;
                            {new Date().getFullYear()}
                        </div>
                    </div>
                </div>

                <p className="a-center">
                    <Link to={"/conditions"} className="link">
                        {t("breadcrumbs.termsandconditions")}
                    </Link>&nbsp;&nbsp;&nbsp;
                    <Link to={'/privacy'} className="link">
                        {t("breadcrumbs.privacy")}
                    </Link>
                    <br/>
                    <br/>
                    <small>{t("footer.gender_notice")}</small>
                </p>
            </div>
        </footer>
    );
};

export default Footer;
